angular.module('tgaAdmin').service('VILTWebsocketActionsService', [
  function () {
    let socket = null;

    function getSocket() {
      return socket;
    }

    function setSocket(s) {
      socket = s;
    }

    const standard = {
      getState: () => {
        socket.emit('session:state:get');
      },
      getLiveSession: () => {
        socket.emit('session:session_live:get');
      },
      broadcastState: () => {
        socket.emit('session:state:broadcast');
      },
      sessionEnded: () => {
        socket.emit('session:ended');
      },
      setFeedbackIndex: (advanced_feedback_index) => {
        socket.emit('session:state:update', {
          state: {
            advanced_feedback_index,
          },
        });
      },
      mute: (game_mute) => {
        socket.emit('session:state:update', {
          state: {
            game_mute,
          },
        });
      },
      showPoll: () => {
        socket.emit('session:state:update', {
          state: {
            show_poll: true,
            show_leaderboard: false,
          },
        });
      },
      showAnswers: () => {
        socket.emit('session:state:update', {
          state: {
            advanced_feedback_index: -1,
            show_answers: true,
            show_leaderboard: false,
            show_poll: false,
          },
        });
      },
      start: () => {
        socket.emit('session:state:update', {
          state: {
            game_start: true,
            show_leaderboard: false,
          },
        });
      },
      showLeaderboard: (show_leaderboard = true) => {
        if (show_leaderboard) {
          socket.emit('session:leaderboard:update');
        }
        socket.emit('session:state:update', {
          state: {
            show_leaderboard,
          },
        });
      },
    };

    const jeopardy = {
      backToBoard: () => {
        socket.emit('session:state:update', {
          state: {
            advanced_feedback_index: -1,
            back_to_board: true,
            hide_modal: false,
            show_answers: false,
            show_clue: false,
            show_correct: false,
            show_final_wager: false,
            show_final_jpd: false,
            show_leaderboard: false,
          },
        });
      },
      hideWager: () => {
        socket.emit('session:state:update', {
          state: {
            back_to_board: false,
            hide_modal: true,
            show_answers: false,
            show_clue: false,
            show_correct: false,
            show_leaderboard: false,
            show_final_wager: false,
            show_final_jpd: false,
            skip_to_final_jpd: false,
          },
        });
      },
      showAnswers: () => {
        socket.emit('session:state:update', {
          state: {
            advanced_feedback_index: -1,
            back_to_board: false,
            hide_modal: false,
            show_answers: true,
            show_clue: false,
            show_correct: false,
            show_final_wager: false,
            show_final_jpd: false,
            show_leaderboard: false,
          },
        });
      },
      showClue: () => {
        socket.emit('session:state:update', {
          state: {
            back_to_board: false,
            hide_modal: false,
            show_answers: false,
            show_clue: true,
            show_correct: false,
            show_final_wager: false,
            show_final_jpd: false,
            show_leaderboard: false,
          },
        });
      },
      showCorrect: () => {
        socket.emit('session:state:update', {
          state: {
            back_to_board: false,
            hide_modal: false,
            show_answers: false,
            show_clue: false,
            show_correct: true,
            show_final_wager: false,
            show_final_jpd: false,
            show_leaderboard: false,
          },
        });
      },
      skipToFinalJpd: () => {
        socket.emit('session:state:update', {
          state: {
            advanced_feedback_index: -1,
            back_to_board: true,
            hide_modal: false,
            show_answers: false,
            show_clue: false,
            show_correct: false,
            show_final_wager: false,
            show_final_jpd: false,
            show_leaderboard: false,
            skip_to_final_jpd: true,
          },
        });
      },
      showFinalJeopardy: () => {
        socket.emit('session:state:update', {
          state: {
            back_to_board: false,
            hide_modal: false,
            show_answers: false,
            show_clue: false,
            show_correct: false,
            show_final_wager: false,
            show_final_jpd: true,
            show_leaderboard: false,
          },
        });
      },
      start: () => {
        socket.emit('session:state:update', {
          state: {
            game_start: true,
            show_leaderboard: false,
          },
        });
      },
    };

    return {
      getSocket,
      setSocket,
      standard,
      jeopardy,
    };
  },
]);
